import '../styles/components/Footer.scss'
import { SlSocialFacebook } from "react-icons/sl";
import { PiInstagramLogoLight } from "react-icons/pi";
import { SlSocialLinkedin } from "react-icons/sl";
import wetekup from '../assets/icons/wetekup.svg'
import { useLocation } from "react-router-dom";
import phone from '../assets/icons/phone.svg'
import logo from '../assets/logo.svg'
import { GrLocation } from "react-icons/gr";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import { useState } from 'react';
import { MdMailOutline } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const location = useLocation()
    const [expandedSections, setExpandedSections] = useState({
        accueil: false,
        contact: false,
        organismes: false
    })

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }))
    }

    return (
        <footer className="footer" style={{ borderTop: '1px solid #D3D3D3' }}>
            <div className='footer-main'>
                <div className='footer-description'>
                    <img src={logo} alt='2SC Consulting logo' />
                    <p>
                        {t('footer.description').split('*').map((line, index, array) => (
                            <span key={index}>
                                {line}
                                {index < array.length - 1 && <br/>}
                            </span>
                        ))}
                    </p>
                </div>
                <div className='footer-quick-links'>
                    <div className='accordion-header' onClick={() => toggleSection('accueil')}>
                        <h3> {t('footer.quickLinks')} </h3>
                        <span className='mobile-chevron'>{expandedSections.accueil ? <IoChevronUpOutline /> : <IoChevronDownOutline />}</span>
                    </div>
                    <div className={`accordion-content ${expandedSections.accueil ? 'expanded' : ''}`}>
                        <h3> {t('footer.quickLinks')} </h3>
                        <a href='/AboutUs'>{t('footer.aboutUs')}</a>
                        <a href='/creation-entreprise'>{t('footer.creation')}</a>
                        <a href='/domiciliation-entreprise'>{t('footer.domiciliation')}</a>
                        <a href='/comptabilite'>{t('footer.accounting')}</a>
                        <a href='/FAQ'>{t('footer.faq')}</a>
                        <a href='/mentions-legales'>{t('footer.legalNotice')}</a>
                        <a href='/politique-confidentialite'>{t('footer.privacyPolicy')}</a>
                    </div>
                </div>
                <div className='footer-contact'>
                    <div className='accordion-header' onClick={() => toggleSection('contact')}>
                        <h3> {t('footer.contact')} </h3>
                        <span className='mobile-chevron'>{expandedSections.contact ? <IoChevronUpOutline /> : <IoChevronDownOutline />}</span>
                    </div>
                    <div className={`accordion-content ${expandedSections.contact ? 'expanded' : ''}`}>
                        <h3> {t('footer.contact')} </h3>
                        <p> <MdMailOutline /> <a href='mailto:contact@2scomptapro.com'>contact@2scomptapro.com</a>    </p>
                        <p> <img src={phone} alt='phone' /> <a href='https://wa.me/21620372623' target='_blank' rel='noopener noreferrer'>+216 20 372 623</a>  </p>
                        <p> <GrLocation /> 52 Avenue Othman Ibn Affan,  <br/> Menzah 8, 2037 Ariana </p>
                    </div>
                </div>
                <div className='legals-social-contacts'>
                    <div className='accordion-header' onClick={() => toggleSection('organismes')}>
                        <h3> {t('footer.organisms')} </h3>
                        <span className='mobile-chevron'>{expandedSections.organismes ? <IoChevronUpOutline /> : <IoChevronDownOutline />}</span>
                    </div>
                    <div className={`accordion-content ${expandedSections.organismes ? 'expanded' : ''}`}>
                        <h3> {t('footer.organisms')} </h3>
                        <a href='http://www.tunisieindustrie.nat.tn' target='_blank'>APII</a>
                        <a href='http://www.cepex.nat.tn' target='_blank'>CEPEX</a>
                        <a href='https://www.cnss.tn' target='_blank'>CNSS</a>
                    </div>
                    <h4 className='nous-trouver'> {t('footer.findUs')} </h4>
                    <div className='social-icons'>
                        <a href='https://www.facebook.com/2Sfirms/' target='_blank'><SlSocialFacebook  size={26} /></a>
                        <a href='https://www.instagram.com/comptapro77/' target='_blank'><PiInstagramLogoLight size={28} /></a>
                        <a href='https://www.linkedin.com/company/2s-comptapro' target='_blank'><SlSocialLinkedin size={26} /></a>
                    </div>
                </div>
            </div>
            <hr />
            <div className='footer-copyrights'>
                <img src={wetekup} alt='wetekup logo minimal' />
                <span> 
                    © {new Date().getFullYear()}, 2SC Consulting. {t('footer.copyright')}
                    <a href='https://www.instagram.com/we.tekup/' target='_blank'> WE TEKUP</a>
                </span>
            </div>
        </footer>
    )
}

export default Footer
